import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Spacing from '@marvelapp/marvel-ui/spacing';

import colorStyles from './style/color.module.css';

const cx = classNames.bind({ ...colorStyles });

export default function Line({ spacing, color, position }) {
  const className = cx(color);
  return (
    <Spacing type="margin" size={spacing} position={position}>
      <div className={className} style={{ height: 1 }} />
    </Spacing>
  );
}

Line.propTypes = {
  color: PropTypes.oneOf(Object.keys(colorStyles)),
  position: PropTypes.string,
  spacing: PropTypes.string,
};

Line.defaultProps = {
  spacing: 'xl',
  color: 'smoke',
  position: 'topBottom',
};



// WEBPACK FOOTER //
// ./src/components/modules/Line/index.js